import type { IModularBenefitMessages } from '@ben/shared/types/columbia';
import { memo } from 'react';
import { FormProvider } from 'react-hook-form';
import ManagerAndProvider from '../manager-and-provider/manager-and-provider';
import { SectionContainer } from './styles';
import type { ManagerForm } from './types';

interface ManagerAndProviderElementProps {
  form: ManagerForm;
  errors: Record<string, boolean>;
  warnings: IModularBenefitMessages;
  successes: IModularBenefitMessages;
  isScheduledVersion: boolean;
}

const ManagerAndProviderElement = ({
  form,
  errors,
  warnings,
  successes,
  isScheduledVersion,
}: ManagerAndProviderElementProps) => (
  <SectionContainer>
    <FormProvider {...form}>
      <ManagerAndProvider
        errors={errors}
        warnings={warnings}
        successes={successes}
        isScheduledVersion={isScheduledVersion}
      />
    </FormProvider>
  </SectionContainer>
);

export default memo(ManagerAndProviderElement);
